import React, { useEffect, useRef, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import AnalyticsApi from "../../apis/analytics.api";
import ReviewApi from "../../apis/review.api";
import AppAlert from "../../components/AppAlert";
import AppLogo from "../../components/AppLogo";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import SolidDisabledBtn from "../../components/buttons/SolidDisabledBtn";
import CheckBox from "../../components/CheckBox";
import CountableInput from "../../components/CountableInput";
import CountableTextArea from "../../components/CountableTextArea";
import PopupArea from "../../components/modal/PopupArea";
import Spinner from "../../components/spinner/Spinner";
import TopPageBack from "../../components/TopPageBack";
import { RESULT_MSG,APP_TYPES } from "../../constants/AppConstants";
import useAuth from "../../hooks/useAuth";
import {
  APPLY_TO_STORE,
  CONTENT,
  SELECT_ALL,
  TITLE,
  TOTAL_APPLY,
  WRITE_COMMENT,
} from "../../text-data";
import CantSeeSomeStore from "./CantSeeSomeStore";
const StyledDiv = styled.div`
  /* Reply area */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 20px;
  gap: 16px;
  border-top: 1px solid #e6eaf2;
  width: 100%;
`;

export default function ReviewSettingAdditionalCommentSetting() {
  const textAreaRef = useRef(null);
  const { ceoInfo } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const contentMaxLength = 200;

  const reviewSettingItem = state?.reviewSettingItem;
  const additionList = state?.additionList;
  const [storesData, setStoresData] = useState([]);
  const [popupContent, setPopupContent] = useState(null);
  const closeModal = () => setPopupContent(null);
  const [isCheckAll, setCheckAll] = useState(false);
  const [ceoStoreIds, setCeoStoreIds] = useState([]);
  const [titleComment, setTitleComment] = useState(
    reviewSettingItem?.title ?? ""
  );

  const [content, setContent] = useState(
    reviewSettingItem?.content ?? ""
  );
  const [loading, setLoading] = useState(false);

  const [openDuplicate, setOpenDuplicate] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openMaximum, setOpenMaximum] = useState(false);

  const ChooseStore = ({ rsacAppName, rsacStoreName, rsacStoreId }) => {
    const onChange = () => {
      if (ceoStoreIds.includes(rsacStoreId)) {
        setCeoStoreIds(ceoStoreIds.filter((id) => id !== rsacStoreId));
      } else {
        setCeoStoreIds([...ceoStoreIds, rsacStoreId]);
      }
    };
    return (
      <div className="flex gap-2 items-center">
        <AppLogo isByName={true} appName={rsacAppName} size={32} />
        <b className="text-darkblue" style={{ maxWidth: "calc(100% - 80px)" }}>
          [{rsacAppName}] {rsacStoreName}
        </b>
        <div className="ml-auto text-end">
          <CheckBox
            checked={ceoStoreIds.includes(rsacStoreId)}
            onChange={onChange}
          />
        </div>
      </div>
    );
  };

  const onSubmit = async () => {
    let isDuplicate = false;
    const dataRequest = {
      title: titleComment,
      content: textAreaRef.current.value,
      shop_idx: ceoInfo?.shop_idx,
      store_idx_arr: ceoStoreIds,
    };
    if (additionList && additionList.length > 0 && !reviewSettingItem) {
      const duplicateList = additionList?.filter(
        (x) => x.title === dataRequest.title
      );
      if (duplicateList.length > 0) {
        isDuplicate = true;
      }
    }

    if (isDuplicate) {
      setOpenDuplicate(true);
      return;
    }

    try {
      setLoading(true);
      if (reviewSettingItem) {
        await ReviewApi.editAddition({
          ...dataRequest,
          additional_comment_idx: reviewSettingItem?.additional_comment_idx,
        });
        setOpenSuccess(true);
      } else {
        const { data } = await ReviewApi.createAddition(dataRequest);
        if (data && data.result_msg === RESULT_MSG.MAXIMUM_ADDITIONAL) {
          setOpenMaximum(true);
        } else {
          setOpenSuccess(true);
        }
      }
    } finally {
      setLoading(false);
    }
  };
  const TotalApplyBtn = () => {
    if (ceoStoreIds.length && content && titleComment && content.length <= contentMaxLength) {
      return (
        <SolidBlueBtn
          disabled={loading}
          className="w-full py-4 flex items-center justify-center"
          onClick={onSubmit}
        >
          <Spinner isLoading={loading} />
          {TOTAL_APPLY.replace("$1", ceoStoreIds.length)}
        </SolidBlueBtn>
      );
    }
    return (
      <SolidDisabledBtn className="w-full py-4" onClick={onSubmit}>
        {TOTAL_APPLY.replace("$1", ceoStoreIds.length)}
      </SolidDisabledBtn>
    );
  };

  const onClear = () => {
    if (textAreaRef.current) {
      textAreaRef.current.value = "";
    }
  };

  const getApplyStores = async () => {
    if (ceoInfo.shop_idx) {
      let appTypeCodes = {appTypeCodes: APP_TYPES.Beamin.type+','+APP_TYPES.Yogiyo.type};
      const { data } = await AnalyticsApi.getStoresByDeliveryApp(ceoInfo.shop_idx,appTypeCodes);

      setStoresData(data.data);

      if (reviewSettingItem) {
        const existedValues = data.data.filter((value) =>
          reviewSettingItem?.addtionalCommentStores
            ?.filter((x) => x.applied)
            ?.some((item) => item.store_idx === value.store_idx)
        );
        const selectedItems = existedValues?.map((item) =>
          item.store_idx?.toString()
        );
        setCeoStoreIds(selectedItems);

        if (selectedItems.length === data.data?.length) {
          setCheckAll(true);
        }
      }
    }
  };
  useEffect(() => {
    getApplyStores();
  }, []);

  return (
    <div className="flex flex-col">
      <TopPageBack padHeight="0px">
        <b>{WRITE_COMMENT}</b>
      </TopPageBack>
      <PopupArea popupContent={popupContent} closeModal={closeModal} />
      <StyledDiv>
        <div className="font-bold mb-2 text-lg text-darkblue">{TITLE}</div>
        <CountableInput
          onChange={(v) => {
            setTitleComment(v);
          }}
          placeholder={"사장님에게만 보여요"}
          defaultValue={reviewSettingItem?.title}
        />
      </StyledDiv>
      <StyledDiv>
        <div className="font-bold mb-2 text-lg text-darkblue">{CONTENT}</div>
        <CountableTextArea
          textAreaRef={textAreaRef}
          defaultValue={reviewSettingItem?.content}
          onChange={(v) => setContent(v)}
          onClear={onClear}
          placeholder={"추천 댓글 아래에 이어서 붙어요"}
          maxLength={contentMaxLength}
        />
      </StyledDiv>
      <StyledDiv>
        <div className="w-full flex justify-between">
          <div className="font-bold mb-2 text-lg text-darkblue">
            {APPLY_TO_STORE}
          </div>
          <CheckBox
            label={SELECT_ALL}
            checked={isCheckAll}
            onChange={() => {
              const checked = !isCheckAll;
              setCheckAll(checked);
              if (checked) {
                setCeoStoreIds(storesData.map((x) => x.store_idx.toString()));
              } else {
                setCeoStoreIds([]);
              }
            }}
          />
        </div>
        <CantSeeSomeStore />
      </StyledDiv>

      <div className="px-5 flex flex-col gap-6">
        {storesData.map((x, index) => {
          return (
            <ChooseStore
              key={index}
              rsacAppName={x.app_name}
              rsacStoreName={x.store_name}
              rsacStoreId={x.store_idx.toString()}
            />
          );
        })}
      </div>
      <div className="mt-7 mb-2 px-5">
        <TotalApplyBtn />
      </div>

      <AppAlert
        title="다른 제목을 입력해 주세요."
        desc="이미 동일한 제목이 사용되고 있어요."
        open={openDuplicate}
        onOk={() => setOpenDuplicate(false)}
        okText="확인"
        type="error"
      />

      <AppAlert
        title="추가 댓글 설정이 완료되었어요!"
        desc="다음 리뷰부터 추가 댓글이 적용돼요."
        open={openSuccess}
        onOk={() => {
          setOpenSuccess(false);
          navigate(-1);
        }}
        okText="확인"
        type="success"
      />

      <AppAlert
        title="추가 댓글은 최대 3개까지 생성됩니다."
        open={openMaximum}
        onOk={() => setOpenMaximum(false)}
        okText="확인"
        type="error"
      />
    </div>
  );
}
